import { render } from "./Invoice_Details.vue?vue&type=template&id=35a2372a"
import script from "./Invoice_Details.vue?vue&type=script&lang=js"
export * from "./Invoice_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__